import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeaturesDefaultProps, FeaturesPropTypes } from './Features.proptypes';
import useFeatures from './useFeatures';

const Features = ({ className, details, isLightDisplay }) => {
  const { t } = useTranslation();

  const { getDetails, getValue } = useFeatures({ details });

  if (getDetails.length > 0) {
    return (
      <div
        className={cn('features', className, {
          'features-light': isLightDisplay,
        })}
        data-qa-id="features"
      >
        <h2 className="h2">{t('common:entities:product.features.title')}</h2>
        <ul className="list list--features" data-qa-id="features-list">
          {getDetails.map((detail) => (
            <li
              className="list__item"
              key={`detail-${detail.code}-${detail.value}`}
              data-qa-id="item"
            >
              <span className="list__label" data-qa-id="label">
                {detail.label}
              </span>
              <span className="list__value" data-qa-id="value">
                {getValue(detail)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return null;
};

Features.defaultProps = {
  ...FeaturesDefaultProps,
};

Features.propTypes = {
  ...FeaturesPropTypes,
};

export default Features;
